<template>
  <page-header></page-header>
  <div class="innerBanner what-we-do-banner position-relative">
    <div class="inBannerImg">
      <img src="../assets/what-we-do_banner.png" alt="Couriers" />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase">Postmedia Parcel Services</h1>
          <span class="pe-lg-4 p-0"
            ><strong>Canada’s Delivery Network</strong><br />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="post-media_section text-center mt-5">
    <div class="container-sm">
      <p>
        Postmedia Parcel Services is a comprehensive, reliable, and trusted
        service supporting eCommerce and retail delivery for businesses across
        Canada. Using the latest technology, our customers can rest assured that
        their packages are in good hands. Our goal is to provide a quality
        delivery services for businesses coast to coast in an efficient and
        timely manner, while keeping customers up-to-date throughout the
        process. As a division of Postmedia, one of Canada’s largest media
        networks, we know how to get your parcel to doorsteps across the
        country.
      </p>
    </div>
  </div>

  <!--     <div class="we_integrate text-center">
        <div class="container-sm">
            <div class="row">
                <div class="col-lg-8 mx-auto">
                    <div class="we-integrate_subheading">We integrate tactics to</div>
                    <h2 class="my-3">MAXIMIZE YOUR IMPACT AND RETURN ON INVESTMENT</h2>
                    <p class="mb-3">on the Postmedia network and beyond.</p>
                    <a href="" class="bg-warning d-inline-block click-here-btn position-relative"><img src='https://postmediaparcelservices.com/wp-content/themes/bniparcel/images/arrow-reverse.png' alt="arrow" class="img-fluid"> Learn More</a>
                </div>
            </div>
        </div>
    </div> -->
  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Need more information or support?</p>
          <a href="https://postmediaparcelservices.com/support" title=""
            >Get in touch with us today!</a
          >
        </h5>
      </div>
    </div>
  </div>

  <!-- Track Parcel page Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="p-4 fs-3">
            Proof of Delivery, review the delivery image
          </div>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "./PageFooter.vue";
import PageHeader from "./PageHeader.vue";

export default {
  beforeMount() {
    scroll(0, 0);
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
};
</script>
